// extracted by mini-css-extract-plugin
module.exports = {"container":"common_container__jWNY8","wrapper":"common_wrapper__3ESpM","container2":"common_container2__2wK89","link":"common_link__2_Oc7","error":"common_error__1foO0"};